import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { Globals } from '../../providers/globals';

import { PaymentMethod } from '../../models/payment-method';

import { PaymentMethodManagementPage } from '../payment-method-management/payment-method-management';
import { PaymentMethodHandler } from '../../providers/payment-method-handler';

/**
 * Generated class for the PaymentMethodListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
 
@Component({
  selector: 'page-payment-method-list',
  templateUrl: 'payment-method-list.html',
})
export class PaymentMethodListPage {
	hasMethods: boolean = false;
	methodList: any;
	closeOnAdd: any;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public paymentMethodHandler: PaymentMethodHandler,
	) {
		if(this.paymentMethodHandler.paymentMethods.length>0){
			this.methodList = this.paymentMethodHandler.paymentMethods;
			this.hasMethods = true;
		}

		this.paymentMethodHandler.paymentMethodList.subscribe(data => {
			if(this.paymentMethodHandler.paymentMethods.length>0){
				this.hasMethods = true;
			}else{
				this.hasMethods = false;
			}
			
			this.methodList = this.paymentMethodHandler.paymentMethods;
		});

		this.closeOnAdd = navParams.get('closeOnAdd');
	}

	addNewMethod(){
	    this.navCtrl.push(PaymentMethodManagementPage, {
	      	method: {
				"number": "",
				"expiry": "",
				"name": "",
				"cvc": "",
				"cardType": ""				    		
	    	},
	    	closeOnAdd: this.closeOnAdd,
	    	caller: this
	    });		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad PaymentMethodListPage');
	}

}



// WEBPACK FOOTER //
// ./src/pages/payment-method-list/payment-method-list.ts